// extracted by mini-css-extract-plugin
export default {"cursorPointer":"icons_cursorPointer__Jc38H"};